import { render, staticRenderFns } from "./stockReceive.vue?vue&type=template&id=e32533a4&"
import script from "./stockReceive.vue?vue&type=script&lang=js&"
export * from "./stockReceive.vue?vue&type=script&lang=js&"
import style0 from "./stockReceive.vue?vue&type=style&index=0&id=e32533a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports